<template>
  <div>
    <div class="bg-wrapper hidden pc:block">
      <div class="bg mx-auto flex max-w-[1920px] items-center justify-center py-[76px]">
        <p class="text-[40px] font-bold text-neutral-950">성인 과정</p>
      </div>
    </div>

    <section class="pb-[70px] pt-[55px] pc:pb-[140px] pc:pt-[70px]">
      <div>
        <div class="show-list flex items-center justify-between bg-[#323740] p-2 pc:hidden">
          <div class="w-3"></div>
          <p class="text-sm font-bold text-white">과정 리스트 보기</p>
          <div class="w-3">
            <img src="@/assets/images/courseIntroduce/adult/arrow.png" alt="icon" class="show-arrow transition-all" />
          </div>
        </div>
        <ul class="lang-list flex pc:mx-auto pc:max-w-[1200px] pc:flex-col">
          <li class="w-[40%] bg-[#ececec] pc:w-full pc:bg-white">
            <ul class="gap-10 border-solid border-[#f1f1f1] pc:flex pc:border-b">
              <li class="cursor-pointer py-3.5 text-center font-medium" @click="goPage('/courseIntroduce/adultEng/PageAll')">
                영어
              </li>
              <li class="cursor-pointer py-3.5 text-center font-medium" @click="goPage('/courseIntroduce/adultChi/pageAll')">
                중국어
              </li>
              <li class="cursor-pointer py-3.5 text-center font-medium" @click="goPage('/courseIntroduce/adultJap/pageAll')">
                일본어
              </li>
              <li
                class="cursor-pointer py-3.5 text-center font-medium text-[#fb6930]"
                @click="goPage('/courseIntroduce/adultEtc')"
              >
                제2외국어
              </li>
            </ul>
          </li>
          <li class="w-[60%] pc:w-full">
            <ul class="country-list gap-9 divide-y divide-solid divide-[#e9e9e9] pc:flex pc:divide-y-0">
              <li class="cursor-pointer py-3.5 text-center font-medium text-[#666666]">
                <a href="#lang1">독일어</a>
              </li>
              <li class="cursor-pointer py-3.5 text-center font-medium text-[#666666]">
                <a href="#lang2">러시아어</a>
              </li>
              <li class="cursor-pointer py-3.5 text-center font-medium text-[#666666]">
                <a href="#lang3">베트남어</a>
              </li>
              <li class="cursor-pointer py-3.5 text-center font-medium text-[#666666]">
                <a href="#lang4">스페인어</a>
              </li>
              <li class="cursor-pointer py-3.5 text-center font-medium text-[#666666]">
                <a href="#lang5">아랍어</a>
              </li>
              <li class="cursor-pointer py-3.5 text-center font-medium text-[#666666]">
                <a href="#lang6">인도네시아어</a>
              </li>
              <li class="cursor-pointer py-3.5 text-center font-medium text-[#666666]">
                <a href="#lang7">태국어</a>
              </li>
              <li class="cursor-pointer py-3.5 text-center font-medium text-[#666666]">
                <a href="#lang8">포르투갈어</a>
              </li>
              <li class="cursor-pointer py-3.5 text-center font-medium text-[#666666]">
                <a href="#lang9">프랑스어</a>
              </li>
              <li class="cursor-pointer py-3.5 text-center font-medium text-[#666666]">
                <a href="#lang10">이탈리아어</a>
              </li>
              <li class="cursor-pointer py-3.5 text-center font-medium text-[#666666]">
                <a href="#lang11">한국어</a>
              </li>
            </ul>
          </li>
        </ul>
        <div class="pc-con-wrapper5">
          <div class="bg1 mb-7 flex flex-col items-center px-5 py-10 pc:mb-11 pc:py-[90px]">
            <p class="mb-2 text-center text-[35px] font-bold text-white">제2외국어</p>
            <div class="mb-6 h-[2px] w-[72px] bg-[#fb6930]"></div>
            <p class="text-center text-white pc:text-2xl">
              20개 언어, 922명의 강사진과 함께하는 리얼 원어민 수업!<br />언어별 원어민 강사와 직접 얼굴을 보며 진행되는 수준별
              맞춤학습을 통해<br />글로벌 커뮤니케이션 능력을 가장 빠르게 향상시켜 드립니다.
            </p>
          </div>
          <div class="pc-con-wrapper4 px-5">
            <!-- 독일어 -->
            <div id="lang1" class="mb-10 border-b border-solid border-[#ebebeb] pb-10">
              <div class="mb-5 flex items-center gap-2">
                <div class="w-5">
                  <img src="@/assets/images/courseIntroduce/adult/etc/germany.png" alt="img" />
                </div>
                <p class="text-2xl font-bold text-[#111111]">독일어</p>
              </div>
              <ul class="grid grid-cols-2 gap-5 tablet:grid-cols-3 pc:grid-cols-4 pc:gap-10">
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/germany01.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">입문~초급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">입문초급회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                    @click="goSite('https://kr.object.ncloudstorage.com/mailpad/b2b_pdf/ETC01.pdf')"
                  >
                    미리보기
                  </p>
                  <p class="font-medium text-[#111111]">가장 쉬운 독일어 첫걸음의 모든 것</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/germany02.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">초급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">Tangram1_lektion 1-4</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/germany03.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">초급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">Tangram1_lektion 5-8</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/germany04.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">중급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">Tangram2_lektion 1-4</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/germany05.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">중급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">Tangram2_lektion 5-8</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/germany06.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">고급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">Tangram3_lektion 1-4</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/germany07.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">초급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">
                      Zertifikat Deutsch<br />독일어 능력시험
                    </p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">Zertifikat Deutsch 독일어 능력시험 A1</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/germany08.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">초급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">
                      Zertifikat Deutsch<br />독일어 능력시험
                    </p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">Zertifikat Deutsch 독일어 능력시험 A2</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/germany09.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">중급이상</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">
                      Zertifikat Deutsch<br />독일어 능력시험
                    </p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">Zertifikat Deutsch 독일어 능력시험 B1</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/germany10.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">중급이상</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">
                      Zertifikat Deutsch<br />독일어 능력시험
                    </p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">Zertifikat Deutsch 독일어 능력시험 B2</p>
                </li>
              </ul>
            </div>

            <!-- 러시아어 -->
            <div id="lang2" class="mb-10 border-b border-solid border-[#ebebeb] pb-10">
              <div class="mb-5 flex items-center gap-2">
                <div class="w-5">
                  <img src="@/assets/images/courseIntroduce/adult/etc/russia.png" alt="img" />
                </div>
                <p class="text-2xl font-bold text-[#111111]">러시아어</p>
              </div>
              <ul class="grid grid-cols-2 gap-5 tablet:grid-cols-3 pc:grid-cols-4 pc:gap-10">
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/russia01.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">입문~초급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">입문초급회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                    @click="goSite('https://kr.object.ncloudstorage.com/mailpad/b2b_pdf/ETC02.pdf')"
                  >
                    미리보기
                  </p>
                  <p class="font-medium text-[#111111]">가장 쉬운 러시아어 첫걸음의 모든 것</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/russia02.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">초급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">러시아어 인텐시브 회화1</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/russia03.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">중급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">러시아어 인텐시브 회화2</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/russia04.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">중급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">러시아어 인텐시브 회화3</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/russia05.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">고급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">러시아어 인텐시브 회화4</p>
                </li>
              </ul>
            </div>

            <!-- 베트남어 -->
            <div id="lang3" class="mb-10 border-b border-solid border-[#ebebeb] pb-10">
              <div class="mb-5 flex items-center gap-2">
                <div class="w-5">
                  <img src="@/assets/images/courseIntroduce/adult/etc/vietnam.png" alt="img" />
                </div>
                <p class="text-2xl font-bold text-[#111111]">베트남어</p>
              </div>
              <ul class="grid grid-cols-2 gap-5 tablet:grid-cols-3 pc:grid-cols-4 pc:gap-10">
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/vietnam01.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">입문~초급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">튼튼한 기초 베트남어</p>
                  </div>
                  <p
                    class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                    @click="goSite('https://kr.object.ncloudstorage.com/mailpad/b2b_pdf/ETC03.pdf')"
                  >
                    미리보기
                  </p>
                  <p class="font-medium text-[#111111]">튼튼한 기초 베트남어</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/vietnam02.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">초급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                    @click="goSite('https://kr.object.ncloudstorage.com/mailpad/b2b_pdf/ETC04.pdf')"
                  >
                    미리보기
                  </p>
                  <p class="font-medium text-[#111111]">버전업! 가장 쉬운 베트남어 첫걸음</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/vietnam03.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">중급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                    @click="goSite('https://kr.object.ncloudstorage.com/mailpad/b2b_pdf/ETC05.pdf')"
                  >
                    미리보기
                  </p>
                  <p class="font-medium text-[#111111]">Vietnamese as a Second Language 1</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/vietnam04.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">중급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                    @click="goSite('https://kr.object.ncloudstorage.com/mailpad/b2b_pdf/ETC06.pdf')"
                  >
                    미리보기
                  </p>
                  <p class="font-medium text-[#111111]">Vietnamese as a Second Language 2</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/vietnam05.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">고급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">OPI 시험대비</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">한 번에 끝! OPI 베트남어</p>
                </li>
              </ul>
            </div>

            <!-- 스페인어 -->
            <div id="lang4" class="mb-10 border-b border-solid border-[#ebebeb] pb-10">
              <div class="mb-5 flex items-center gap-2">
                <div class="w-5">
                  <img src="@/assets/images/courseIntroduce/adult/etc/spain.png" alt="img" />
                </div>
                <p class="text-2xl font-bold text-[#111111]">스페인어</p>
              </div>
              <ul class="grid grid-cols-2 gap-5 tablet:grid-cols-3 pc:grid-cols-4 pc:gap-10">
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/spain01.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">입문~중급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">입문초급회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                    @click="goSite('https://kr.object.ncloudstorage.com/mailpad/b2b_pdf/ETC07.pdf')"
                  >
                    미리보기
                  </p>
                  <p class="font-medium text-[#111111]">가장 쉬운 스페인어 첫걸음의 모든 것</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/spain02.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">입문~초급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">스페인어 첫걸음</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">스페인어 첫걸음</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/spain03.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">입문~초급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">Espanol En Directo</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">Espanol En Directo</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/spain04.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">초급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">Nuevo Espanol En Marcha 1</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/spain05.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">초중급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">Nuevo Espanol En Marcha 2</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/spain06.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">중급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">Nuevo Espanol En Marcha 3</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/spain07.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">중고급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">Nuevo Espanol En Marcha 4</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/spain08.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">중고급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">토론회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                    @click="goSite('https://kr.object.ncloudstorage.com/mailpad/b2b_pdf/ETC08.pdf')"
                  >
                    미리보기
                  </p>
                  <p class="font-medium text-[#111111]">Spanish topic discussion1</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/spain09.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">중고급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">토론회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                    @click="goSite('https://kr.object.ncloudstorage.com/mailpad/b2b_pdf/ETC09.pdf')"
                  >
                    미리보기
                  </p>
                  <p class="font-medium text-[#111111]">Spanish topic discussion2</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/spain10.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">중급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">DELE 시험대비</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">Preparacion DELE B1</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/spain11.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">중고급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">DELE 시험대비</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">Preparacion DELE B2</p>
                </li>
              </ul>
            </div>

            <!-- 아랍어 -->
            <div id="lang5" class="mb-10 border-b border-solid border-[#ebebeb] pb-10">
              <div class="mb-5 flex items-center gap-2">
                <div class="w-5">
                  <img src="@/assets/images/courseIntroduce/adult/etc/arab.png" alt="img" />
                </div>
                <p class="text-2xl font-bold text-[#111111]">아랍어</p>
              </div>
              <ul class="grid grid-cols-2 gap-5 tablet:grid-cols-3 pc:grid-cols-4 pc:gap-10">
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/arab01.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">입문~중급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">입문초급회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                    @click="goSite('https://kr.object.ncloudstorage.com/mailpad/b2b_pdf/ETC10.pdf')"
                  >
                    미리보기
                  </p>
                  <p class="font-medium text-[#111111]">버전업! 가장 쉬운 아랍어 첫걸음</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/arab02.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">입문~중급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">종합 아랍어</p>
                </li>
              </ul>
            </div>

            <!-- 인도네시아어 -->
            <div id="lang6" class="mb-10 border-b border-solid border-[#ebebeb] pb-10">
              <div class="mb-5 flex items-center gap-2">
                <div class="w-5">
                  <img src="@/assets/images/courseIntroduce/adult/etc/indonesia.png" alt="img" />
                </div>
                <p class="text-2xl font-bold text-[#111111]">인도네시아어</p>
              </div>
              <ul class="grid grid-cols-2 gap-5 tablet:grid-cols-3 pc:grid-cols-4 pc:gap-10">
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/indonesia01.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">입문~중급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">입문초급회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                    @click="goSite('https://kr.object.ncloudstorage.com/mailpad/b2b_pdf/Indonesia.pdf')"
                  >
                    미리보기
                  </p>
                  <p class="font-medium text-[#111111]">가장 쉬운 인도네시아어 첫걸음의 모든 것</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/indonesia02.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">입문~초급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">THE 바른 인도네시아어 STEP1</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/indonesia03.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">초중급~중급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">THE 바른 인도네시아어 STEP2</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/indonesia04.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">중급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">인도네시아어 대화 읽기 중급</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/indonesia05.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">중급~고급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">Biz. Speaking</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">비즈니스 인도네시아어 한국어</p>
                </li>
              </ul>
            </div>

            <!-- 태국어 -->
            <div id="lang7" class="mb-10 border-b border-solid border-[#ebebeb] pb-10">
              <div class="mb-5 flex items-center gap-2">
                <div class="w-5">
                  <img src="@/assets/images/courseIntroduce/adult/etc/thailand.png" alt="img" />
                </div>
                <p class="text-2xl font-bold text-[#111111]">태국어</p>
              </div>
              <ul class="grid grid-cols-2 gap-5 tablet:grid-cols-3 pc:grid-cols-4 pc:gap-10">
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/thailand01.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">입문~중급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">입문초급회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                    @click="goSite('https://kr.object.ncloudstorage.com/mailpad/b2b_pdf/ETC11.pdf')"
                  >
                    미리보기
                  </p>
                  <p class="font-medium text-[#111111]">버전업! 가장 쉬운 태국어 첫걸음</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/thailand02.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">중~고급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">심화</p>
                  </div>
                  <p
                    class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                    @click="goSite('https://kr.object.ncloudstorage.com/mailpad/b2b_pdf/ETC12.pdf')"
                  >
                    미리보기
                  </p>
                  <p class="font-medium text-[#111111]">첫걸음 끝내고 보는 태국어 중고급의 모든 것</p>
                </li>
              </ul>
            </div>

            <!-- 포르투갈어 -->
            <div id="lang8" class="mb-10 border-b border-solid border-[#ebebeb] pb-10">
              <div class="mb-5 flex items-center gap-2">
                <div class="w-5">
                  <img src="@/assets/images/courseIntroduce/adult/etc/portugal.png" alt="img" />
                </div>
                <p class="text-2xl font-bold text-[#111111]">포르투갈어</p>
              </div>
              <ul class="grid grid-cols-2 gap-5 tablet:grid-cols-3 pc:grid-cols-4 pc:gap-10">
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/portugal01.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">입문~초급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">입문초급회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                    @click="goSite('https://kr.object.ncloudstorage.com/mailpad/b2b_pdf/ETC13.pdf')"
                  >
                    미리보기
                  </p>
                  <p class="font-medium text-[#111111]">가장 쉬운 포르투갈어 첫걸음의 모든 것</p>
                </li>
              </ul>
            </div>

            <!-- 프랑스어 -->
            <div id="lang9" class="mb-10 border-b border-solid border-[#ebebeb] pb-10">
              <div class="mb-5 flex items-center gap-2">
                <div class="w-5">
                  <img src="@/assets/images/courseIntroduce/adult/etc/france.png" alt="img" />
                </div>
                <p class="text-2xl font-bold text-[#111111]">프랑스어</p>
              </div>
              <ul class="grid grid-cols-2 gap-5 tablet:grid-cols-3 pc:grid-cols-4 pc:gap-10">
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/france01.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">입문~초급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">입문초급회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                    @click="goSite('https://kr.object.ncloudstorage.com/mailpad/b2b_pdf/ETC14.pdf')"
                  >
                    미리보기
                  </p>
                  <p class="font-medium text-[#111111]">가장 쉬운 프랑스어 첫걸음의 모든것(Basic French)</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/france02.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">초급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">Festival1</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/france03.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">초급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">Festival2</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/france04.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">고급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">Festival3</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/france05.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">초급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">DELF 시험대비</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">DELF A1</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/france06.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">초급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">DELF 시험대비</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">DELF B1</p>
                </li>
              </ul>
            </div>

            <!-- 이탈리아어 -->
            <div id="lang10" class="mb-10 border-b border-solid border-[#ebebeb] pb-10">
              <div class="mb-5 flex items-center gap-2">
                <div class="w-5">
                  <img src="@/assets/images/courseIntroduce/adult/etc/italy.png" alt="img" />
                </div>
                <p class="text-2xl font-bold text-[#111111]">이탈리아어</p>
              </div>
              <ul class="grid grid-cols-2 gap-5 tablet:grid-cols-3 pc:grid-cols-4 pc:gap-10">
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/italy01.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">입문~초급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">입문</p>
                  </div>
                  <p
                    class="mb-1 inline-block cursor-pointer rounded-2xl border border-solid border-[fb6930] px-3.5 text-sm font-medium text-[#fb6930]"
                    @click="goSite('https://kr.object.ncloudstorage.com/mailpad/b2b_pdf/ETC15.pdf')"
                  >
                    미리보기
                  </p>
                  <p class="font-medium text-[#111111]">가장 쉬운 이탈리아어 첫걸음의 모든 것</p>
                </li>
              </ul>
            </div>

            <!-- 한국어 -->
            <div id="lang11">
              <div class="mb-5 flex items-center gap-2">
                <div class="w-5">
                  <img src="@/assets/images/courseIntroduce/adult/etc/korea.png" alt="img" />
                </div>
                <p class="text-2xl font-bold text-[#111111]">한국어</p>
              </div>
              <ul class="grid grid-cols-2 gap-5 tablet:grid-cols-3 pc:grid-cols-4 pc:gap-10">
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/korea01.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">입문~초급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">한국어 일상회화1</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/korea02.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">초급~초중급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">한국어 일상회화2</p>
                </li>
                <li>
                  <div class="relative mb-2.5 overflow-hidden rounded-xl">
                    <img src="@/assets/images/courseIntroduce/adult/etc/korea03.png" alt="img" />
                    <p class="absolute left-0 top-0 bg-black/60 px-3 py-1 text-white">초중급~중급</p>
                    <p class="custom-shadow absolute bottom-0 w-full pb-3.5 text-center text-white">일반회화</p>
                  </div>
                  <p
                    class="mb-1 inline-block rounded-2xl border border-solid border-[8b8b8b] px-3.5 text-sm font-medium text-[#8b8b8b]"
                  >
                    외부교재
                  </p>
                  <p class="font-medium text-[#111111]">한국어 일상회화3</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { ref, reactive, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import axios from "@/plugins/axios.js";
import { useStore } from "vuex";

export default {
  components: {},

  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    const goPage = (url) => {
      location.href = url;
    };

    const goSite = (url) => {
      window.open(url, "_blank");
    };

    onMounted(() => {
      const showListButton = document.querySelector(".show-list");
      const arrowIcon = showListButton.querySelector(".show-arrow");
      const listToToggle = document.querySelector(".lang-list");
      const countryListItems = document.querySelectorAll(".country-list li a");

      showListButton.addEventListener("click", function () {
        if (listToToggle.style.display === "none") {
          listToToggle.style.display = "flex";
        } else {
          listToToggle.style.display = "none";
        }

        arrowIcon.classList.toggle("rotate-180");
      });

      if (window.innerWidth < 1200) {
        countryListItems.forEach(function (item) {
          item.addEventListener("click", function () {
            listToToggle.style.display = "none";
            arrowIcon.classList.remove("rotate-180");
          });
        });
      }
    });

    return {
      goPage,
      goSite,
    };
  },
};
</script>
<style lang="scss" scoped>
.bg1 {
  background: url(@/assets/images/courseIntroduce/adult/etc/bg.png) no-repeat center / 1920px;
}

.custom-shadow {
  background: linear-gradient(to bottom, rgba(20, 20, 20, 0.05) 0%, rgba(20, 20, 20, 1) 100%);
}
</style>
